const ADD_GYMS_SUCCESS = 'gym/ADD_GYMS_SUCCESS'

const SELECT_GYM_REQUEST = 'gym/SELECT_GYM_REQUEST'
const ADD_SELECTED_GYM_SUCCESS = 'gym/ADD_SELECTED_GYM_SUCCESS'

const UNSELECT_GYM_REQUEST = 'gym/UNSELECT_GYM_REQUEST'
const UNSELECTED_GYM_SUCCESS = 'gym/UNSELECTED_GYM_SUCCESS'

const ADD_PLAN_FILTER_REQUEST = 'gym/ADD_PLAN_FILTER_REQUEST'
const ADD_PLAN_FILTER_SUCCESS = 'gym/ADD_PLAN_FILTER_SUCCESS'

const GYM_SEARCH_REQUEST = 'gym/GYM_SEARCH_REQUEST'
const GYM_SEARCH_SUCCESS = 'gym/GYM_SEARCH_SUCCESS'

const ADD_GEOLOCATION_FILTER_REQUEST = 'gym/ADD_GEOLOCATION_FILTER_REQUEST'
const ADD_GEOLOCATION_FILTER_SUCCESS = 'gym/ADD_GEOLOCATION_FILTER_SUCCESS'

const INITIAL_VALUES = {
  filter: {
    plan: {
      id: 5,
      title: 'Gold +',
      price: 299.9,
      maxPrice: 559.9,
      gymCount: 22266,
    },
    geolocation: {
      lat: -23.552133,
      lng: -46.6351665,
    },
  },
  gyms: [],
  selectedGym: null,
}

export default function reducer(state = INITIAL_VALUES, action) {
  switch (action.type) {
    case ADD_GYMS_SUCCESS:
      return {
        ...state,
        gyms: [...action.gyms],
      }
    case ADD_SELECTED_GYM_SUCCESS:
      return {
        ...state,
        selectedGym: action.selectedGym,
      }
    case UNSELECTED_GYM_SUCCESS:
      return {
        ...state,
        selectedGym: null,
      }
    case ADD_GEOLOCATION_FILTER_SUCCESS:
      return {
        ...state,
        filter: {
          ...state.filter,
          geolocation: action.geolocation,
        },
      }
    case ADD_PLAN_FILTER_SUCCESS:
      return {
        ...state,
        filter: {
          ...state.filter,
          plan: action.plan,
        },
      }
    default:
      return state
  }
}

function addGymsSuccess(gyms) {
  return {
    type: ADD_GYMS_SUCCESS,
    gyms,
  }
}

function selectGymRequest(selectedGym) {
  return {
    type: SELECT_GYM_REQUEST,
    selectedGym,
  }
}

function unselectGymRequest() {
  return {
    type: UNSELECT_GYM_REQUEST,
  }
}

function selectGymSuccess(selectedGym) {
  return {
    type: ADD_SELECTED_GYM_SUCCESS,
    selectedGym,
  }
}

function unselectGymSuccess() {
  return {
    type: UNSELECTED_GYM_SUCCESS,
  }
}

function addGymSearchGeolocationFilterRequest(geolocation) {
  return {
    type: ADD_GEOLOCATION_FILTER_REQUEST,
    geolocation,
  }
}

function addGymSearchPlanFilterRequest(plan) {
  return {
    type: ADD_PLAN_FILTER_REQUEST,
    plan,
  }
}

function addGymSearchGeolocationFilterSuccess(geolocation) {
  return {
    type: ADD_GEOLOCATION_FILTER_SUCCESS,
    geolocation,
  }
}

function addGymSearchPlanFilterSuccess(plan) {
  return {
    type: ADD_PLAN_FILTER_SUCCESS,
    plan,
  }
}

function gymSearchRequest() {
  return {
    type: GYM_SEARCH_REQUEST,
  }
}

const types = {
  ADD_GYMS_SUCCESS,
  SELECT_GYM_REQUEST,
  ADD_SELECTED_GYM_SUCCESS,
  UNSELECT_GYM_REQUEST,
  UNSELECTED_GYM_SUCCESS,
  ADD_PLAN_FILTER_REQUEST,
  ADD_PLAN_FILTER_SUCCESS,
  GYM_SEARCH_REQUEST,
  GYM_SEARCH_SUCCESS,
  ADD_GEOLOCATION_FILTER_REQUEST,
  ADD_GEOLOCATION_FILTER_SUCCESS,
}

const actions = {
  addGymsSuccess,
  selectGymRequest,
  unselectGymRequest,
  selectGymSuccess,
  unselectGymSuccess,
  addGymSearchGeolocationFilterRequest,
  addGymSearchPlanFilterRequest,
  addGymSearchGeolocationFilterSuccess,
  addGymSearchPlanFilterSuccess,
  gymSearchRequest,
}

export { actions, types }
